import { Component, ViewEncapsulation, forwardRef, OnInit, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl, AbstractControl } from '@angular/forms';
import { CustomValidators } from '../../validators/validators';
import { UUID } from '../../models/other/UUID';
import { formatDate } from '../../formatters/date/format-date.function';

@Component({
    selector: 'emq-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ]
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {


    @Input()
    public formControl?: FormControl;

    @Input()
    public tabindex?: number;

    @Input()
    public label?: string;

    @Input()
    public ngValue: any;

    public isCheckboxOn = false;

    public disabled = false;

    _onChange = (_: any) => { };
    _onTouched = (_: any) => { };


    registerOnChange(fn: any): void { this._onChange = fn; }
    registerOnTouched(fn: any): void { this._onTouched = fn; }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    toggleValue() {
        this.setValue(!this.isCheckboxOn);
    }

    setValue(val: boolean) {

        if (this.disabled) {
            return;
        }

        this.isCheckboxOn = val;

        if (this.isCheckboxOn) {
            this.formControl?.setValue(this.ngValue);
        } else {
            this.formControl?.setValue(null);
        }
    }

    writeValue(obj: any): void {
        if (this.ngValue === obj) {
            this.isCheckboxOn = true;
        } else {
            this.isCheckboxOn = false;
        }
    }



    ngOnInit() {

    }
}
